import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";

import { USER_CACHE_KEY } from "./keys";

import { UserRepository } from "@/repositories/user";

export const useAcquisitionOptions = () => {
  const userRepository = useRef(new UserRepository());

  return useQuery({
    queryKey: [USER_CACHE_KEY, "ACQUISITION_OPTIONS"],
    queryFn: () => userRepository.current.acquisitionOptions(),
    staleTime: 5 * 60 * 1000,
  });
};
